// extracted by mini-css-extract-plugin
module.exports = {"load":"Loading_load__11HE2","ring":"Loading_ring__3auns","loading":"Loading_loading__38WPi"};